import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPurpleLock = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14.37,
	height: 19.16,
	viewBox: "0 0 14.37 19.16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "padlock_3064155",
		d: "M15.574,7.185h-.6V4.79a4.79,4.79,0,1,0-9.58,0V7.185H4.8A1.8,1.8,0,0,0,3,8.981v8.382a1.8,1.8,0,0,0,1.8,1.8H15.574a1.8,1.8,0,0,0,1.8-1.8V8.981A1.8,1.8,0,0,0,15.574,7.185ZM6.992,4.79a3.193,3.193,0,0,1,6.387,0V7.185H6.992Zm3.992,8.56v1.819a.8.8,0,1,1-1.6,0V13.35a1.6,1.6,0,1,1,1.6,0Z",
		transform: "translate(-3)",
		fill: "#7284fa"
	})
});
export default SvgPurpleLock;
